import { z } from 'zod';
export const PaginationSchema = z.object({
    next_cursor: z.string().nullable(),
    has_more: z.boolean(),
});
export function successEnvelope(data) {
    return z.object({ data });
}
export const ApiErrorSchema = z.object({
    error: z.object({
        code: z.enum([
            'bad_request',
            'unauthorized',
            'forbidden',
            'not_found',
            'conflict',
            'rate_limited',
            'unprocessable',
            'unifi_unavailable',
            'server_error',
        ]),
        message: z.string(),
        request_id: z.string().optional(),
        details: z.unknown().optional(),
    }),
});
//# sourceMappingURL=envelope.js.map